import '../styles/SearchResultsList.css';
import { CareHome } from '../types';
import OpenScoreCard from './OpenScoreCard';

interface SearchResultsListProps {
    careHomes: CareHome[];
    onSelectCareHome?: (careHome: CareHome) => void;
    // Action tracking context (update 2026-02-01.1)
    userId?: string;
    startingPostCode?: string;
}



const SearchResultsList = ({ careHomes, onSelectCareHome, userId = '', startingPostCode = '' }: SearchResultsListProps) => {
    if (careHomes.length === 0) {
        return null;
    }

    return (
        <div className="search-results-list">
            <div className="results-container">
                {/* Using composite key to ensure uniqueness across all care homes */}
                {careHomes.map((careHome, index) => (
                    <OpenScoreCard
                        key={`${careHome.id}-${careHome.organisation_id}-${careHome.reg_id}-${index}`}
                        careHome={careHome}
                        onSelect={onSelectCareHome}
                        userId={userId}
                        startingPostCode={startingPostCode}
                        searchPosition={index + 1}  // 1-based position
                    />
                ))}
            </div>
        </div>
    );
};

export default SearchResultsList;
